import API from "@/constants/api";
import { AxiosResponse } from "axios";
import axiosUtil from "@/utils/axios.util";

// interfaces
import { RegisterData } from "@/interfaces/register-data.model";
import { LoginData } from "@/interfaces/login-data.model";

// login
async function loginAdmin(data: LoginData): Promise<AxiosResponse> {
  const url = API.auth.login;
  const body = data;
  return axiosUtil.post(url, body);
}

export const authService = {
  loginAdmin,
};
